import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Sparkles } from 'lucide-react';
const tomos = [{
  id: 'T1',
  title: 'Adiós Hinchazón',
  color: 'bg-brand-accent/10 text-brand-accent border-brand-accent/40'
}, {
  id: 'T2',
  title: 'Paz en 2 Minutos',
  color: 'bg-brand-accent/10 text-brand-accent border-brand-accent/40'
}, {
  id: 'T3',
  title: 'Energía Real',
  color: 'bg-brand-accent/10 text-brand-accent border-brand-accent/40'
}];
export function ProductOverview() {
  return <section className="py-4 bg-brand-card border-t border-brand-border" data-id="element-282">
      <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-283">
        <FadeIn data-id="element-284">
          <div className="inline-flex items-center justify-center p-1.5 bg-brand-cream rounded-full mb-1" data-id="element-285">
            <Sparkles className="w-5 h-5 text-brand-accent" data-id="element-286" />
          </div>
          <h2 className="text-[22px] md:text-3xl font-bold mb-1 leading-[1.2]" data-id="element-287">
            MEGAPACK HINCHADA, CANSADA Y NERVIOSA
          </h2>
          <p className="text-[14px] text-brand-muted leading-snug mb-1" data-id="element-288">
            <span className="font-bold text-brand-dark" data-id="element-289">
              Reset Digestivo y Emocional
            </span>
          </p>
          <p className="text-xs text-brand-muted leading-snug mb-1" data-id="element-290">
            by LibrofyStore™
          </p>
          <p className="text-xs text-brand-muted leading-snug mb-3" data-id="element-291">
            3 Tomos · 60 páginas · Acceso inmediato
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-292">
          <div className="flex flex-row flex-nowrap justify-center gap-1.5" data-id="element-293">
            {tomos.map(t => <div key={t.id} className={`flex items-center gap-1 px-3 py-1.5 rounded-full border text-[12px] ${t.color}`} data-id="element-294">
                <span className="font-bold" data-id="element-295">{t.id}</span>
                <span data-id="element-296">{t.title}</span>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}